export default "__VITE_ASSET__DEz7VHOX__"